import { LevelEntity } from 'shared/domain/level/types/entity';
import { SiteEntity } from 'shared/domain/site/types/entity';
import { LabelledEntity } from 'shared/types/commonView';
import { GridSortCellParams } from '@mui/x-data-grid-pro';
import { InspectionOnTableView } from 'presentation/inspection/inspectionOnView';

export const createLabelSortComparator = <
  T extends { label: string },
>() => {
  return (v1: T[], v2: T[]): number => {
    const firstLabel1 = v1?.[0]?.label || '';
    const firstLabel2 = v2?.[0]?.label || '';
    return firstLabel1.localeCompare(firstLabel2);
  };
};

export const levelsSortComparator =
  createLabelSortComparator<LevelEntity>();
export const sitesSortComparator = createLabelSortComparator<SiteEntity>();

export const processSortComparator = createLabelSortComparator<{
  _id: string;
  label: string;
}>();
export const userSitesSortComparator =
  createLabelSortComparator<LabelledEntity>();
export const userProcessesSortComparator =
  createLabelSortComparator<LabelledEntity>();

function compareByInspectionDate(
  date1: Date | null,
  date2: Date | null
): number {
  if (!date1 || !date2) return 0;
  return date1.getTime() - date2.getTime();
}

function compareByCreatedAt(
  row1: InspectionOnTableView | null,
  row2: InspectionOnTableView | null
): number {
  if (!row1?.createdAt || !row2?.createdAt) return 0;
  
  const millis1 = row1.createdAt.toMillis?.() ?? 0;
  const millis2 = row2.createdAt.toMillis?.() ?? 0;
  
  return millis2 - millis1;
}

function compareById(
  row1: InspectionOnTableView | null,
  row2: InspectionOnTableView | null
): number {
  const id1 = row1?._id ?? '';
  const id2 = row2?._id ?? '';
  return id1.localeCompare(id2);
}

export const executionDateSortComparator = (
  v1: Date | null,
  v2: Date | null,
  param1: GridSortCellParams<InspectionOnTableView>,
  param2: GridSortCellParams<InspectionOnTableView>
): number => {
  const dateComparison = compareByInspectionDate(v1, v2);
  if (dateComparison !== 0) return dateComparison;

  const row1 = param1.api.getRow(param1.id) as InspectionOnTableView;
  const row2 = param2.api.getRow(param2.id) as InspectionOnTableView;

  const createdAtComparison = compareByCreatedAt(row1, row2);
  if (createdAtComparison !== 0) return createdAtComparison;

  return compareById(row1, row2);
};
